import { baseApi } from "./apiConfig.js";

export const getBuyerDetails = async () => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/getBuyerDetails?_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching buyer details:', error);
        throw error;
    }
};
export const getBuyerOffersByName = async ({payload}) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/getBuyerOffers/1?buyer=${payload}&_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching buyer details:', error);
        throw error;
    }
};

export const getBuyerOffers = async (page = 1) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/getBuyerOffers/${page}?_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching buyer offers:', error);
        throw error;
    }
};

export const getCIFDetails = async (bidOfferIds) => {
    try {
        const timestamp = new Date().getTime();
        const payload =
            Array.isArray(bidOfferIds) ? bidOfferIds : [bidOfferIds]


        const response = await baseApi.post(`/portal/api/TRNL/cifDetails?_=${timestamp}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error fetching CIF details:', error);
        throw error;
    }
};


export const getOfferDetailsById = async (activeOfferId) => {
    try {
        if (!activeOfferId) {
            throw new Error('Active offer ID is required');
        }

        // console.log("Calling API with activeOfferId:", activeOfferId);

        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/viewOfferDetails/${activeOfferId}?_=${timestamp}`);

        // console.log('API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error in getOfferDetailsById:', error);
        throw error;
    }
};
// src/api/offers.js

export const getBuyerSelfOffers = async (page = 1, buyerEmail) => {
    try {
        // Generate timestamp
        const timestamp = new Date().getTime();

        // Encode the email for URL
        const encodedEmail = encodeURIComponent(buyerEmail);

        // Construct URL with query parameters
        const url = `/portal/buyerdashboard/getBuyerOffers/${page}?buyer=${encodedEmail}&_=${timestamp}`;

        // console.log('Calling API:', url);

        const response = await baseApi.get(url);

        // console.log('API Response:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error fetching buyer offers:', error);
        throw error;
    }
};


export const getSellerFinalNegotiationDetailsApi = async({listingId}) =>{
    try {
        const timestamp = new Date().getTime();

        const response = await baseApi.get(`portal/getSellerFinalNegotiationDetails?listingId=${listingId}&_=${timestamp}`)
        return response.data;
    } catch (error) {
        console.error("Error fetching seller final negotiation ",error);
        throw error;
    }
}
export const buyerPremiumApi = async({listingId,amount}) =>{
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`portal/buyerPremium/${listingId}/${amount}?_=${timestamp}`)
        return response.data;
    } catch (error) {
        console.error("Error fetching buyer premium ", error);
        throw error;
    }
}

export const submitConfirmOffer = async({listingId,bidId,userId}) =>{
    try {
        const response = await baseApi.post(`/portal/confirmFinalNegotiation/${listingId}/${bidId}/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error calling the submit offer api",error);
        throw error;
    }

}


export const getTrasactionByName = async ({payload,page}) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/previousTransactions/${page}?buyer=${payload}&_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching buyer details:', error);
        throw error;
    }
};

export const withDrawOffer = async({id,payload}) =>{
    try {
        const response = await baseApi.post(`/portal/buyerdashboard/withdrawOffer/${id}`,payload)
        return response.data;
    } catch (error) {
         console.error('Error withdrawing the offer', error);
        throw error;
    }
}
export const getPropertyOffer = async({id,payload}) =>{
    try {        
         const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/getBuyerOffers/0?propertyId=${id}&buyer=${payload?.buyerDetail}&_=${timestamp}`)
        return response.data;
    } catch (error) {
        console.error('Error getting property offer', error);
        throw error;
    }
}
export const isInternal = async({email})=>{
      try {
        const response = await baseApi.get(`/portal/isInternalUser?email${email}`)
        return response.data;
    } catch (error) {
        console.error('Error getting internal user', error);
        throw error;
    }
}

export const getOfferDetailsApi = async({id})=>{
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/counterOfferDetails/${id}?_=${timestamp}`)
        return response.data;
    } catch (error) {
        console.error('Error getting offer details', error);
        throw error;
    }
}

export const getHnBApi = async({id})=>{
    try {
         const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/hnbOfferDetails/${id}?_=${timestamp}`)
        return response.data;
    } catch (error) {
        console.error('Error getting hnb offer', error);
        throw error;
    }
}   

export const placeCounterOffer =async(paylaod)=>{
    try {
        const response = await baseApi.post(`/portal/buyerdashboard/placeCounterOffer`, paylaod)
        return response.data;
    } catch (error) {
        console.error('Error placing counter offer', error);
        throw error;
    }

}
export const hnbOfferApi = async (payload) =>{
 try {
        const response = await baseApi.post(`/portal/buyerdashboard/placeHnBOffer`, payload)
        return response.data;
    } catch (error) {
        console.error('Error placing counter offer', error);
        throw error;
    }

}
export const rejectOfferApi = async({id,payload}) =>{
    try {
        const response = await baseApi.post(`/portal/buyerdashboard/rejectOffer/${id}`,payload)
        return response.data;
    } catch (error) {
         console.error('Error withdrawing the offer', error);
        throw error;
    }
}
export const acceptOfferApi = async({id,payload}) =>{
    try {
        const response = await baseApi.post(`/portal/buyerdashboard/acceptOffer/${id}`,payload)
        return response.data;
    } catch (error) {
         console.error('Error withdrawing the offer', error);
        throw error;
    }
}